import {
  AreaChartOutlined,
  BarChartOutlined,
  LineChartOutlined,
  MobileOutlined,
  ShoppingOutlined,
  ThunderboltOutlined
} from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import { PERMISSIONS } from 'modules/permission';
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const reports: NavItemType = {
  id: 'reports',
  title: <FormattedMessage id="reports" />,
  type: 'group',
  permission: PERMISSIONS.REPORTS.READ,
  children: [
    {
      id: 'orders-analytics',
      title: <FormattedMessage id="order-analytics" />,
      type: 'item',
      url: '/reports/order-analytics',
      icon: LineChartOutlined,
      permission: PERMISSIONS.REPORTS.READ
    },
    {
      id: 'performance-report',
      title: <FormattedMessage id="performance-report" />,
      type: 'item',
      url: '/reports/performance-report',
      icon: BarChartOutlined,
      permission: PERMISSIONS.REPORTS.READ
    },
    {
      id: 'performance-trend',
      title: <FormattedMessage id="performance-trend" />,
      type: 'item',
      url: '/reports/performance-trend',
      icon: AreaChartOutlined,
      permission: PERMISSIONS.REPORTS.READ
    },
    {
      id: 'productInsights',
      title: <FormattedMessage id="product-insights" />,
      type: 'item',
      url: '/reports/product-insights',
      icon: ShoppingOutlined,
      permission: PERMISSIONS.REPORTS.READ
    },
    {
      id: 'cashReport',
      title: <FormattedMessage id="cashReport" />,
      type: 'item',
      url: '/reports/cashReport',
      icon: BarChartOutlined,
      permission: PERMISSIONS.REPORTS.READ
    },
    {
      id: 'delivery-challenge-analytics',
      title: <FormattedMessage id="delivery-challenge-analytics" />,
      type: 'item',
      url: '/reports/delivery-challenge-analytics',
      icon: ThunderboltOutlined,
      permission: PERMISSIONS.DELIVERY_CHALLENGES.READ
    },
    {
      id: 'app-usage',
      title: <FormattedMessage id="app-usage" />,
      type: 'item',
      url: '/reports/app-usage',
      icon: MobileOutlined,
      permission: PERMISSIONS.REPORTS.READ
    }
  ]
};
export default reports;
